import { useDialog } from "@platform/store";
import type { DeletionInvitation } from "@core/features/invitation";
import { InvitationDeletionDialog } from "./InvitationDeletionDialog";
import { useProgram } from "@platform/hooks/useProgram";

export function ProgramFriendInviteDeletion() {
  const { program } = useProgram();
  const { activeDialog, closeDialog, dialogProps } = useDialog();

  const isOpen = activeDialog === "invitationDelete";

  // Invitation data should be passed via dialogProps when opening the dialog
  const invitation = dialogProps?.invitation;

  if (!invitation || !program) return null;

  const handleDone = async () => {
    // TODO: Refetch relevant data after invitation deleted
    // close the dialog
    closeDialog();
  };

  return (
    <InvitationDeletionDialog
      onDone={handleDone}
      onClose={handleDone}
      isOpen={isOpen}
      invitation={invitation as DeletionInvitation}
      programId={program.id}
    />
  );
}

export default ProgramFriendInviteDeletion;
